import React from 'react';
import Chip from '@mui/material/Chip';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

function getModelLabel(payrollType) {
  if (payrollType === 'HOURLY') return 'Saatlik';
  if (payrollType === 'MONTHLY') return 'Aylık';
  if (payrollType === 'PERCENTAGE') return 'Yüzdelik';
  return 'Tanımsız';
}

function getDefinedPriceText(value) {
  if (value?.payrollType === 'HOURLY') {
    const privateRate = value?.privateLessonHourlyRate || '—';
    const groupRate = value?.groupLessonHourlyRate || '—';
    return `Özel ${privateRate} • Grup ${groupRate}`;
  }

  return '—';
}

export default function PayrollSettingsHeaderMini({ staff, value }) {
  return (
    <MDBox
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        flexWrap: 'wrap',
      }}
    >
      <MDBox sx={{ minWidth: 180 }}>
        <MDTypography variant="button" fontWeight="bold" sx={{ lineHeight: 1.1 }}>
          {staff?.fullName || 'Eğitmen'}
        </MDTypography>

        <MDTypography
          variant="caption"
          sx={{ display: 'block', color: 'text.secondary', lineHeight: 1.1, mt: 0.25 }}
        >
          {getModelLabel(value?.payrollType)} • {getDefinedPriceText(value)}
        </MDTypography>
      </MDBox>

      <Chip
        size="small"
        label={getModelLabel(value?.payrollType)}
        sx={{
          height: 24,
          borderRadius: '999px',
          fontWeight: 700,
        }}
      />
    </MDBox>
  );
}
